<template>
  <div id="contenedor-listado-insumos-desktop">
    <v-data-table :headers="headers" :items="listadoInsumos" :items-per-page="20">
      <template v-slot:[`item.tipo`]="{ item }">
        {{ getTipoTexto(item.tipo) }}
      </template>
      <template v-slot:[`item.acciones`]="{ item }">
        <opciones :insumo="item"></opciones>
      </template>
      <template v-slot:[`item.createdAt`]="{ item }">
        <fecha-humano :fecha="new Date(item.createdAt)"></fecha-humano>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import Opciones from './Opciones.vue';
import FechaHumano from '@/components/FechaHumano.vue';

export default {
  name: 'ListadoInsumosDesktop',
  props: {
    listadoInsumos: {
      type: Array,
      required: true,
    },
  },
  components: {
    Opciones,
    FechaHumano,
  },
  data() {
    return {
      headers: [
        { text: 'Orden', value: 'orden' },
        {
          text: 'Descripción',
          align: 'start',
          value: 'descripcion',
        },
        {
          text: 'Tipo',
          align: 'center',
          value: 'tipo',
        },
        { text: 'F. Registro', value: 'createdAt' },
        {
          text: '', value: 'acciones', align: 'end', sortable: false,
        },
      ],
    };
  },
  methods: {
    getTipoTexto(tipo) {
      if (tipo === 1) return 'Personal';
      if (tipo === 2) return 'Maquinaria';
      if (tipo === 3) return 'Equipo';
      return '';
    },
  },
};
</script>

<style lang="scss">
</style>
